export var CommunicationMode;
(function (CommunicationMode) {
    /** Unspecified communication mode */
    CommunicationMode["COMMUNICATION_MODE_UNSPECIFIED"] = "COMMUNICATION_MODE_UNSPECIFIED";
    /** Full response mode, the agent will respond with a full message */
    CommunicationMode["FULL_RESPONSE"] = "FULL_RESPONSE";
    /** Polling mode, the agent will respond with a function call and the client should send another request to continue processing and repeat action untill the agent responds with a full message */
    CommunicationMode["POLLING"] = "POLLING";
})(CommunicationMode || (CommunicationMode = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
export var LogSource;
(function (LogSource) {
    LogSource["CHAT_SERVICE"] = "CHAT_SERVICE";
    LogSource["AGENT_PLATFORM"] = "AGENT_PLATFORM";
    LogSource["PROMPT_HUB"] = "PROMPT_HUB";
})(LogSource || (LogSource = {}));
export var LogType;
(function (LogType) {
    LogType["LLM_COMPLETION"] = "LLM_COMPLETION";
    LogType["TOOL_CALL"] = "TOOL_CALL";
    LogType["TOOL_CALL_RESULT"] = "TOOL_CALL_RESULT";
    LogType["WIDGET"] = "WIDGET";
    LogType["RETRIEVAL"] = "RETRIEVAL";
    LogType["SET_MODE"] = "SET_MODE";
    LogType["SET_FLOW"] = "SET_FLOW";
    LogType["AGENT_INSTRUCTIONS"] = "AGENT_INSTRUCTIONS";
    LogType["LOG_SCOPE"] = "LOG_SCOPE";
    LogType["GENERIC_LOG"] = "GENERIC_LOG";
    LogType["AGENT_LOADER_MESSAGE"] = "AGENT_LOADER_MESSAGE";
    LogType["ASSISTANT_REFERENCE"] = "ASSISTANT_REFERENCE";
    LogType["CRITIC"] = "CRITIC";
    LogType["KEEPER"] = "KEEPER";
    LogType["EVALUATION_CHAT_PANEL"] = "EVALUATION_CHAT_PANEL";
    LogType["DECISION"] = "DECISION";
    LogType["KNOWLEDGE"] = "KNOWLEDGE";
    LogType["UNKNOWN"] = "UNKNOWN";
    LogType["USER_MESSAGE"] = "USER_MESSAGE";
    LogType["CONTEXT_CALL"] = "CONTEXT_CALL";
    LogType["GENERATE_RESPONSE"] = "GENERATE_RESPONSE";
    LogType["REQUIREMENT"] = "REQUIREMENT";
    LogType["SIMULATION"] = "SIMULATION";
    LogType["ANALYSIS"] = "ANALYSIS";
})(LogType || (LogType = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN"] = "UNKNOWN";
    Role["USER"] = "USER";
    Role["ASSISTANT"] = "ASSISTANT";
})(Role || (Role = {}));
export var Status;
(function (Status) {
    Status["STATUS_UNSPECIFIED"] = "STATUS_UNSPECIFIED";
    Status["STATUS_PENDING"] = "STATUS_PENDING";
    Status["STATUS_COMPLETED"] = "STATUS_COMPLETED";
})(Status || (Status = {}));
export var TenantType;
(function (TenantType) {
    TenantType["DEFAULT"] = "DEFAULT";
    TenantType["SERVICE"] = "SERVICE";
})(TenantType || (TenantType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map